if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      findImgByMediaId(mediaId, excludeModal) {
        if (!mediaId) return null;
        const imgs = document.querySelectorAll(`img[data-media-id="${mediaId}"]`);
        for (const img of imgs) {
          const insideModal = this.contains(img);
          if (excludeModal ? !insideModal : insideModal) return img;
        }
        return imgs.length ? imgs[0] : null;
      }

      getMediaImg(el, fromGallery) {
        if (!el) return null;
        if (el.tagName === 'IMG') return el;
        let img = el.querySelector('img');
        if (img) return img;
        const mediaId = el.getAttribute && el.getAttribute('data-media-id');
        return this.findImgByMediaId(mediaId, fromGallery);
      }

      hide() {
        const activeMediaImg = this.getMediaImg(this.querySelector('[data-media-id].active'));
        const openerImg = this.getMediaImg(this.openedBy, true);
        const canAnimate = document.startViewTransition && activeMediaImg && openerImg;

        const runHide = () => super.hide();

        if (!canAnimate) {
          runHide();
          return;
        }

        activeMediaImg.style.viewTransitionName = 'product-zoom-media';
        const transition = document.startViewTransition(() => {
          runHide();
          activeMediaImg.style.viewTransitionName = '';
          openerImg.style.viewTransitionName = 'product-zoom-media';
        });
        transition.finished.finally(() => {
          openerImg.style.viewTransitionName = '';
        });
      }

      show(opener) {
        const openerImg = this.getMediaImg(opener, true);
        const canAnimate = document.startViewTransition && openerImg;

        const runShow = () => {
          super.show(opener);
          this.showActiveMediaCore();
        };

        if (!canAnimate) {
          runShow();
          this.finishActiveMediaScroll();
          return;
        }

        openerImg.style.viewTransitionName = 'product-zoom-media';
        const transition = document.startViewTransition(() => {
          runShow();
          openerImg.style.viewTransitionName = '';
          const activeMediaImg = this.getMediaImg(this.querySelector('[data-media-id].active'));
          if (activeMediaImg) activeMediaImg.style.viewTransitionName = 'product-zoom-media';
        });
        transition.finished.finally(() => {
          const activeMediaImg = this.getMediaImg(this.querySelector('[data-media-id].active'));
          if (activeMediaImg) activeMediaImg.style.viewTransitionName = '';
          this.finishActiveMediaScroll();
        });
      }

      showActiveMedia() {
        this.showActiveMediaCore();
        this.finishActiveMediaScroll();
      }

      showActiveMediaCore() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this._activeMediaEl = activeMedia;
      }

      finishActiveMediaScroll() {
        const activeMedia = this._activeMediaEl;
        if (!activeMedia) return;
        activeMedia.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
      }
    }
  );
}